/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgreementsDto } from '../../models/agreements-dto';
import { LanguageEnum } from '../../models/language-enum';

export interface GetAgreements$Params {
  language?: LanguageEnum;
}

export function getAgreements(http: HttpClient, rootUrl: string, params?: GetAgreements$Params, context?: HttpContext): Observable<StrictHttpResponse<AgreementsDto>> {
  const rb = new RequestBuilder(rootUrl, getAgreements.PATH, 'get');
  if (params) {
    rb.query('language', params.language, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgreementsDto>;
    })
  );
}

getAgreements.PATH = '/api/user/agreements';
